import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { environment } from '@env/environment';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
//import { LoadInterceptor } from '@shared/_http-interceptors/loading-bar-interceptor';
import { ApiRequestTokenInterceptor } from '@shared/_http-interceptors/api-request-token-interceptor';
import { TokenErrorResponseInterceptor } from '@shared/_http-interceptors/token-error-reponse-interceptor';
import { ErrorResponseInterceptor } from '@shared/_http-interceptors/error-body-response-interceptor';
import { provideToastr } from 'ngx-toastr';
import { getApiBaseUrl } from '@shared/_services/runtime-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr(),
    provideAnimations(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: 'API_BASE_URL',
      useValue: getApiBaseUrl(),
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: LoadInterceptor,
    //   multi: true
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenErrorResponseInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorResponseInterceptor,
      multi: true,
    },
  ],
};
